"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const expression_1 = require("./expression");
exports.model = {
    bool() {
        return expression_1.expression.newUnion('bool', expression_1.expression.newStruct());
    },
    dateTime() {
        return expression_1.expression.newUnion('dateTime', expression_1.expression.newStruct());
    },
    string() {
        return expression_1.expression.newUnion('string', expression_1.expression.newStruct());
    },
    optional(type) {
        return expression_1.expression.newUnion('optional', type);
    },
    enum(...options) {
        return expression_1.expression.newUnion('enum', expression_1.expression.newList(...options.map(option => {
            if (typeof option === 'string') {
                return expression_1.expression.newString(option);
            }
            return option;
        })));
    },
    int() {
        return expression_1.expression.newUnion('int', expression_1.expression.newStruct());
    },
    int8() {
        return expression_1.expression.newUnion('int8', expression_1.expression.newStruct());
    },
    int16() {
        return expression_1.expression.newUnion('int16', expression_1.expression.newStruct());
    },
    int32() {
        return expression_1.expression.newUnion('int32', expression_1.expression.newStruct());
    },
    int64() {
        return expression_1.expression.newUnion('int64', expression_1.expression.newStruct());
    },
    uint() {
        return expression_1.expression.newUnion('uint', expression_1.expression.newStruct());
    },
    uint8() {
        return expression_1.expression.newUnion('uint8', expression_1.expression.newStruct());
    },
    uint16() {
        return expression_1.expression.newUnion('uint16', expression_1.expression.newStruct());
    },
    uint32() {
        return expression_1.expression.newUnion('uint32', expression_1.expression.newStruct());
    },
    uint64() {
        return expression_1.expression.newUnion('uint64', expression_1.expression.newStruct());
    },
    float() {
        return expression_1.expression.newUnion('float', expression_1.expression.newStruct());
    },
    map(type) {
        return expression_1.expression.newUnion('map', type);
    },
    list(type) {
        return expression_1.expression.newUnion('list', type);
    },
    set(type) {
        return expression_1.expression.newUnion('set', type);
    },
    struct(fields = {}) {
        return expression_1.expression.newUnion('struct', expression_1.expression.newMap(fields));
    },
    tuple(...types) {
        return expression_1.expression.newUnion('tuple', expression_1.expression.newList(...types));
    },
    union(fields = {}) {
        return expression_1.expression.newUnion('union', expression_1.expression.newMap(fields));
    },
    ref(ref) {
        return expression_1.expression.newUnion('ref', ref);
    },
    annotation(value, model) {
        return expression_1.expression.newUnion('annotation', expression_1.expression.newStruct({
            value: expression_1.expression.newString(value), model
        }));
    },
    recursion(label, model) {
        return expression_1.expression.newUnion('recursion', expression_1.expression.newStruct({
            label: expression_1.expression.newString(label), model
        }));
    },
    recurse(label) {
        return expression_1.expression.newUnion('recurse', expression_1.expression.newString(label));
    },
    recursive(top, models) {
        return expression_1.expression.newUnion('recursive', expression_1.expression.newStruct({
            top: expression_1.expression.newString(top), models: expression_1.expression.newMap(models)
        }));
    },
    unique(model) {
        return expression_1.expression.newUnion('unique', model);
    }
};
//# sourceMappingURL=model.js.map